export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13688.b664c3c1.jpg";